export default __webpack_public_path__ + "static/media/2_2.f3e054d2.jpg";